module.exports = "<ui-view ng-class=\"{'layout-small-menu': $ctrl.layout.isSmallSidebar, 'layout-chat-open': $ctrl.layout.isChatOpen, 'layout-fixed-header': $ctrl.layout.isFixedHeader, 'layout-boxed': $ctrl.layout.isBoxed, 'layout-static-sidebar': $ctrl.layout.isStaticSidebar, 'layout-right-sidebar': $ctrl.layout.isRightSidebar, 'layout-fixed-footer': $ctrl.layout.isFixedFooter, 'message-open': $ctrl.ThemeAppService.isMessageOpen}\"></ui-view>";


//////////////////
// WEBPACK FOOTER
// ./~/@abosol/theme/src/app/main/application.html
// module id = 377
// module chunks = 1